module.exports = __webpack_public_path__ + "static/media/star-icon.01e34bd3.svg";